"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setChannel = void 0;

var http_1 = require("./http");

var uri = "/v4/user";

function setChannel(channel, credentials) {
  return http_1.authorizedHTTP(credentials).post(uri + "/messagingchannel", channel, {
    baseURL: "https://id.comsel.net"
  }).then(function (resp) {
    return resp.data;
  });
}

exports.setChannel = setChannel;

function default_1(credentials, id) {
  var params = {};

  if (id != null) {
    params['uuid'] = id;
  }

  return http_1.authorizedHTTP(credentials).get(uri, {
    params: params,
    baseURL: "https://id.comsel.net"
  }).then(function (resp) {
    return resp.data;
  });
}

exports.default = default_1;